let useLog = !import.meta.client
let initialized = false

type consoleMethods = 'log' | 'warn' | 'error' | 'info'

function consoleHelper(name: consoleMethods, contents: any) {
  if (!initialized) {
    checkUseLog()
  }
  if (!useLog) {
    return
  }
  console[name](...contents)
}

function checkUseLog() {
  if (!import.meta.client) {
    useLog = process.env.NODE_ENV === 'development'
    initialized = true
    return
  }
  try {
    useLog = !!window.localStorage.getItem(STORAGE_NAME.CLIENT_LOG)
  } catch {
    useLog = false
  }

  initialized = true
}

export function log(...contents: any): void {
  consoleHelper('log', contents)
}

export function warn(...contents: any): void {
  consoleHelper('warn', contents)
}

export function error(...contents: any): void {
  consoleHelper('error', contents)
}

export function info(...contents: any): void {
  consoleHelper('info', contents)
}
